import React from 'react';

/**
 * Monochrome Shade mark for rows of muted platform glyphs (the supported-platforms
 * line, the media menu): the same isometric stack as ShadeColorIcon, drawn in
 * currentColor with one opacity per face so the depth survives without the brand
 * purples. Paths from app.shade.inc/images/logo.svg (2026-10-06).
 *
 * The artwork is portrait (1033 x 1188); width/height keep that aspect ratio for
 * `width: auto` callers.
 */
const ShadeIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1033 1188"
      width="16"
      height="18"
      fill="currentColor"
    >
      {/* left faces */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.7"
        d="M0 891.927V718.052L516.143 1015.37V1187.3L0 891.927Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.7"
        d="M516.143 1015.37L258.071 617.902L516.143 766.56V594.63L0 297.314V469.244L258.071 866.709L516.143 1015.37Z"
      />
      {/* right faces */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.85"
        d="M1032.29 891.927V718.052L516.143 1015.37V1187.3L1032.29 891.927Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.85"
        d="M1032.29 471.19V297.314L516.143 594.63V766.56L1032.29 471.19Z"
      />
      {/* the shadowed inner faces */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.5"
        d="M1032.28 718.051L516.143 1015.37L258.071 617.903L516.143 766.56L915.414 538.062L1032.28 718.051Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.5"
        d="M0 718.051L117.577 650.328L258.071 866.709L0 718.051Z"
      />
      {/* top face */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 297.315L516.143 594.63L1032.29 297.315L516.143 0L0 297.315Z"
      />
    </svg>
  );
};

export default ShadeIcon;
